import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check, Phone, ZoomIn } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import AnimatedSection from '../components/AnimatedSection';
import Lightbox from '../components/Lightbox';
import { useLanguage } from '../i18n/pageTranslations';

const Liposuccion = () => {
  const lang = useLanguage();

  const texts = {
    es: {
      eyebrow: 'Cirugía Corporal',
      title: 'Liposucción',
      subtitle: 'Lipoescultura · Lipolaser',
      description: 'Redefinición del contorno corporal mediante la eliminación de depósitos de grasa localizada que no responden a dieta ni ejercicio. Técnicas avanzadas para resultados naturales.',
      requestAssessment: 'Solicitar Valoración',
      callNow: 'Llamar Ahora',
      realResults: 'Resultados reales de Liposucción',
      before: 'Antes',
      after: 'Después',
      posteriorView: 'Vista posterior',
      lateralView: 'Vista lateral',
      realCases: 'Casos reales - Resultados pueden variar según cada paciente',
      techniquesTitle: 'Técnicas',
      techniquesSubtitle: 'Tecnología avanzada',
      techniques: [
        { titulo: 'Liposucción Tumescente', descripcion: 'Técnica estándar con solución infiltrada que facilita la extracción y minimiza el sangrado.' },
        { titulo: 'Lipolaser', descripcion: 'Laser que licua la grasa antes de aspirarla. Produce retracción cutánea adicional.' },
        { titulo: 'Lipoescultura', descripcion: 'Remodelación corporal de alta definición. Combinable con transferencia de grasa.' },
      ],
      areasTitle: 'Áreas tratables',
      areas: ['Abdomen', 'Flancos (cartucheras)', 'Espalda', 'Brazos', 'Muslos', 'Papada', 'Rodillas', 'Tobillos'],
      ctaTitle: '¿Desea más información?',
      ctaDesc: 'Solicite una consulta de valoración personalizada.',
      contact: 'Contactar',
    },
    en: {
      eyebrow: 'Body Surgery',
      title: 'Liposuction',
      subtitle: 'Liposculpture · Lipolaser',
      description: 'Body contour redefinition by removing localized fat deposits that do not respond to diet or exercise. Advanced techniques for natural results.',
      requestAssessment: 'Request Assessment',
      callNow: 'Call Now',
      realResults: 'Real Liposuction Results',
      before: 'Before',
      after: 'After',
      posteriorView: 'Posterior view',
      lateralView: 'Lateral view',
      realCases: 'Real cases - Results may vary for each patient',
      techniquesTitle: 'Techniques',
      techniquesSubtitle: 'Advanced technology',
      techniques: [
        { titulo: 'Tumescent Liposuction', descripcion: 'Standard technique with infiltrated solution that facilitates extraction and minimizes bleeding.' },
        { titulo: 'Lipolaser', descripcion: 'Laser that liquefies fat before suctioning. Produces additional skin retraction.' },
        { titulo: 'Liposculpture', descripcion: 'High definition body remodeling. Combinable with fat transfer.' },
      ],
      areasTitle: 'Treatable areas',
      areas: ['Abdomen', 'Flanks (love handles)', 'Back', 'Arms', 'Thighs', 'Double chin', 'Knees', 'Ankles'],
      ctaTitle: 'Want more information?',
      ctaDesc: 'Request a personalized assessment consultation.',
      contact: 'Contact',
    },
    fr: {
      eyebrow: 'Chirurgie Corporelle',
      title: 'Liposuccion',
      subtitle: 'Liposculpture · Lipolaser',
      description: 'Redéfinition du contour corporel par élimination des dépôts de graisse localisée qui ne répondent ni au régime ni à l\'exercice. Techniques avancées pour des résultats naturels.',
      requestAssessment: 'Demander une Évaluation',
      callNow: 'Appeler Maintenant',
      realResults: 'Résultats réels de Liposuccion',
      before: 'Avant',
      after: 'Après',
      posteriorView: 'Vue postérieure',
      lateralView: 'Vue latérale',
      realCases: 'Cas réels - Les résultats peuvent varier selon chaque patient',
      techniquesTitle: 'Techniques',
      techniquesSubtitle: 'Technologie avancée',
      techniques: [
        { titulo: 'Liposuccion Tumescente', descripcion: 'Technique standard avec solution infiltrée qui facilite l\'extraction et minimise les saignements.' },
        { titulo: 'Lipolaser', descripcion: 'Laser qui liquéfie la graisse avant de l\'aspirer. Produit une rétraction cutanée supplémentaire.' },
        { titulo: 'Liposculpture', descripcion: 'Remodelage corporel haute définition. Combinable avec transfert de graisse.' },
      ],
      areasTitle: 'Zones traitables',
      areas: ['Abdomen', 'Flancs (poignées d\'amour)', 'Dos', 'Bras', 'Cuisses', 'Double menton', 'Genoux', 'Chevilles'],
      ctaTitle: 'Vous voulez plus d\'informations?',
      ctaDesc: 'Demandez une consultation d\'évaluation personnalisée.',
      contact: 'Contacter',
    },
    pt: {
      eyebrow: 'Cirurgia Corporal',
      title: 'Lipoaspiração',
      subtitle: 'Lipoescultura · Lipolaser',
      description: 'Redefinição do contorno corporal mediante a eliminação de depósitos de gordura localizada que não respondem a dieta nem exercício. Técnicas avançadas para resultados naturais.',
      requestAssessment: 'Solicitar Avaliação',
      callNow: 'Ligar Agora',
      realResults: 'Resultados reais de Lipoaspiração',
      before: 'Antes',
      after: 'Depois',
      posteriorView: 'Vista posterior',
      lateralView: 'Vista lateral',
      realCases: 'Casos reais - Resultados podem variar segundo cada paciente',
      techniquesTitle: 'Técnicas',
      techniquesSubtitle: 'Tecnologia avançada',
      techniques: [
        { titulo: 'Lipoaspiração Tumescente', descripcion: 'Técnica padrão com solução infiltrada que facilita a extração e minimiza o sangramento.' },
        { titulo: 'Lipolaser', descripcion: 'Laser que liquefaz a gordura antes de aspirá-la. Produz retração cutânea adicional.' },
        { titulo: 'Lipoescultura', descripcion: 'Remodelação corporal de alta definição. Combinável com transferência de gordura.' },
      ],
      areasTitle: 'Áreas tratáveis',
      areas: ['Abdômen', 'Flancos (culotes)', 'Costas', 'Braços', 'Coxas', 'Papada', 'Joelhos', 'Tornozelos'],
      ctaTitle: 'Deseja mais informações?',
      ctaDesc: 'Solicite uma consulta de avaliação personalizada.',
      contact: 'Contatar',
    },
  };

  const t = texts[lang] || texts.es;

  const [lbImages, setLbImages] = useState([]);
  const [lbIndex, setLbIndex] = useState(0);
  const [lbOpen, setLbOpen] = useState(false);
  const openLb = (imgs, i) => { setLbImages(imgs); setLbIndex(i); setLbOpen(true); };

  const caseImgs = [
    { src: '/images/liposuccion-caso1-pre-posterior.jpeg', alt: t.before, caption: `${t.before} — ${t.posteriorView}`, view: t.posteriorView },
    { src: '/images/liposuccion-caso1-pre-lateral.jpeg', alt: t.before, caption: `${t.before} — ${t.lateralView}`, view: t.lateralView },
    { src: '/images/liposuccion-caso1-post-posterior.jpeg', alt: t.after, caption: `${t.after} — ${t.posteriorView}`, view: t.posteriorView },
    { src: '/images/liposuccion-caso1-post-lateral.jpeg', alt: t.after, caption: `${t.after} — ${t.lateralView}`, view: t.lateralView },
  ];

  return (
    <div className="min-h-screen bg-[#FDFBF8]">
      <Header />
      
      {/* Hero */}
      <section className="pt-32 pb-20 bg-[#FDFBF8]">
        <div className="container mx-auto px-6 max-w-6xl">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <AnimatedSection animation="fadeRight">
              <p className="text-sm tracking-[0.3em] uppercase text-[#B8975A] mb-6">{t.eyebrow}</p>
              <h1 className="font-serif text-5xl md:text-6xl text-[#1C1C1A] mb-2 leading-tight">{t.title}</h1>
              <p className="text-lg text-[#B8975A] mb-6">{t.subtitle}</p>
              <div className="w-20 h-[2px] bg-[#B8975A] mb-8"></div>
              <p className="text-lg text-[#4A4845] leading-relaxed mb-8">{t.description}</p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/contacto" className="inline-flex items-center justify-center gap-2 bg-[#B8975A] text-white px-8 py-4 text-sm tracking-wider uppercase hover:bg-[#96784a] transition-colors">
                  {t.requestAssessment}
                  <ArrowRight size={16} />
                </Link>
                <a href="tel:+34952764547" className="inline-flex items-center justify-center gap-2 border border-[#1C1C1A] text-[#1C1C1A] px-8 py-4 text-sm tracking-wider uppercase hover:bg-[#1C1C1A] hover:text-white transition-colors">
                  <Phone size={16} />
                  {t.callNow}
                </a>
              </div>
            </AnimatedSection>
            <AnimatedSection animation="fadeLeft" className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-[#B8975A]"></div>
              <img src="/images/liposuccion-caso1-post-lateral.jpeg" alt="Liposucción" className="w-full h-auto" />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-[#B8975A]"></div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* Results */}
      <section className="py-20 bg-cream">
        <div className="container mx-auto px-6 max-w-5xl">
          <AnimatedSection animation="fadeUp" className="text-center mb-12">
            <h2 className="font-serif text-3xl md:text-4xl text-charcoal">{t.realResults}</h2>
          </AnimatedSection>
          <div className="flex flex-col md:flex-row gap-12 justify-center">
            {/* Antes */}
            <div>
              <p className="text-center text-charcoal font-serif text-lg mb-4">{t.before}</p>
              <div className="grid grid-cols-2 gap-4">
                {caseImgs.slice(0, 2).map((img, i) => (
                  <div key={i} className="cursor-pointer group relative" onClick={() => openLb(caseImgs, i)}>
                    <div className="aspect-[3/4] overflow-hidden bg-black shadow-lg border-2 border-[#B8975A]/40 p-1">
                      <img src={img.src} alt={img.alt} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                      <div className="absolute inset-1 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center">
                        <ZoomIn className="text-white opacity-0 group-hover:opacity-100 transition-opacity" size={28} />
                      </div>
                    </div>
                    <p className="mt-2 text-text-muted text-xs text-center">{img.view}</p>
                  </div>
                ))}
              </div>
            </div>
            {/* Después */}
            <div>
              <p className="text-center text-charcoal font-serif text-lg mb-4">{t.after}</p>
              <div className="grid grid-cols-2 gap-4">
                {caseImgs.slice(2, 4).map((img, i) => (
                  <div key={i} className="cursor-pointer group relative" onClick={() => openLb(caseImgs, i + 2)}>
                    <div className="aspect-[3/4] overflow-hidden bg-black shadow-lg border-2 border-[#B8975A]/40 p-1">
                      <img src={img.src} alt={img.alt} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                      <div className="absolute inset-1 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center">
                        <ZoomIn className="text-white opacity-0 group-hover:opacity-100 transition-opacity" size={28} />
                      </div>
                    </div>
                    <p className="mt-2 text-text-muted text-xs text-center">{img.view}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <p className="text-center text-text-muted text-sm mt-8">{t.realCases}</p>
        </div>
      </section>

      {/* Técnicas */}
      <section className="py-20 bg-[#1C1C1A]">
        <div className="container mx-auto px-6 max-w-6xl">
          <AnimatedSection animation="fadeUp" className="text-center mb-16">
            <p className="text-sm tracking-[0.3em] uppercase text-[#B8975A] mb-6">{t.techniquesTitle}</p>
            <h2 className="font-serif text-4xl text-white">{t.techniquesSubtitle}</h2>
          </AnimatedSection>
          <div className="grid md:grid-cols-3 gap-8">
            {t.techniques.map((tecnica, index) => (
              <AnimatedSection key={index} animation="fadeUp" delay={index * 0.1}>
                <div className="p-8 border border-[#B8975A]/30 hover:border-[#B8975A] transition-colors h-full">
                  <span className="text-[#B8975A]/40 font-serif text-sm">0{index + 1}</span>
                  <h3 className="font-serif text-2xl text-white mt-2 mb-4">{tecnica.titulo}</h3>
                  <p className="text-white/70">{tecnica.descripcion}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Áreas */}
      <section className="py-20 bg-[#F0EDE7]">
        <div className="container mx-auto px-6 max-w-4xl">
          <AnimatedSection animation="fadeUp" className="text-center mb-12">
            <h2 className="font-serif text-3xl text-[#1C1C1A]">{t.areasTitle}</h2>
          </AnimatedSection>
          <AnimatedSection animation="fadeUp" delay={0.1}>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {t.areas.map((area, index) => (
                <div key={index} className="bg-white p-4 text-center border-b-2 border-[#B8975A]">
                  <span className="text-[#4A4845]">{area}</span>
                </div>
              ))}
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#FDFBF8]">
        <div className="container mx-auto px-6 max-w-3xl text-center">
          <AnimatedSection animation="fadeUp">
            <h2 className="font-serif text-4xl text-[#1C1C1A] mb-6">{t.ctaTitle}</h2>
            <p className="text-[#4A4845] mb-10">{t.ctaDesc}</p>
            <Link to="/contacto" className="inline-flex items-center gap-2 bg-[#B8975A] text-white px-10 py-4 text-sm tracking-wider uppercase hover:bg-[#96784a] transition-colors">
              {t.contact}
              <ArrowRight size={16} />
            </Link>
          </AnimatedSection>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
      {lbOpen && lbImages.length > 0 && <Lightbox images={lbImages} currentIndex={lbIndex} isOpen={lbOpen} onClose={() => setLbOpen(false)} onNavigate={setLbIndex} />}
    </div>
  );
};

export default Liposuccion;
